<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="equi_stage_ouinon" :live="liveSasReconnaissanceArm(9018)" v-model="sasReconnaissanceArm.demandeEquivalenceStage" />
    <data-iterator
      v-if="estOui(sasReconnaissanceArm.demandeEquivalenceStage)"
      :list="sas.sasEquivalenceStage"
      add-new-text="Ajouter une équivalence de stage"
      :live="{ endpoint: 'sas-equivalence-stage', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
      :opq-if="estOui(sasReconnaissanceArm.demandeEquivalenceStage)"
    >
      <template v-slot:edit-mode="{ item }">
        <CatalogueLive code="equi_stage_type" :live="liveSasEquivalenceStage(22702, item)" v-model="item.typeDeDocument" />
        <FileInput code="equi_stage_fichier" :file="item.documentPourEquivalenceDeStage" :live="liveSasEquivalenceStage(22703, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [CataloguesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasReconnaissanceArm() {
      return this.sas.sasReconnaissanceArmFranceQuebec
    }
  },
  methods: {
    liveSasEquivalenceStage(cle, item) {
      return { endpoint: "sas-equivalence-stage", cle: cle, fileId: item.id }
    },
    liveSasReconnaissanceArm(cle) {
      return { endpoint: "sas-reconnaissance-arm-france-quebec", cle: cle, fileId: this.sasReconnaissanceArm.id }
    }
  }
}
</script>

<style></style>
